import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {Doctor, VetClinicData, VisitType} from "../../models/vet-clinic-data.model";
import {NextVisitReminder} from "../../models/next-visit-reminder.model";
import {VetClinicStartContextData} from "../../models/vet-clinic-start-context-data.model";
import {NextVisitReminderSettings} from "../../models/next-visit-reminder-settings.model";
import {UserService} from "../../providers/user.service";
import {Pet} from "../../models/pet.model";
import {AppStateService} from "../../providers/app-state.service";
import {Subscription} from "rxjs";
import {ModalController} from "@ionic/angular";
import {VetineoVisitTypeBundle} from "../../models/vetineo-visit-type-bundle.model";

@Component({
  selector: 'app-next-visit-reminder-visit-type',
  templateUrl: './next-visit-reminder-visit-type.component.html',
  styleUrls: ['./next-visit-reminder-visit-type.component.scss'],
})
export class NextVisitReminderVisitTypeComponent implements OnInit, OnDestroy {

  @Input() nextVisitReminder: NextVisitReminder;

  @Input() vetClinicStartContext: VetClinicStartContextData;
  @Input() clinicData: VetClinicData;
  @Input() nextVisitReminderSettings: NextVisitReminderSettings;
  @Input() title: string;

  useVetineoVisitTypes: boolean = false;
  selectedGVisitType: string;
  selectedGVisitsTypeObj: VisitType[];
  @Output() actionCanceledEmitter = new EventEmitter<NextVisitReminder>();
  minDate: string;
  valueSelected: string;
  doctors: Doctor[];
  selectedDoctor: Doctor;
  isImportant: boolean = false;
  @Input() type: 'users' | 'reservation';
  @Input() isCopy: boolean;
  @Input() petFromVr: Pet;
  calendarClicked: boolean = false;
  days: number = 0;
  pets: Pet[];
  selectedPet: Pet;
  petName: string;
  petsSub: Subscription;
  initVaccNextDateString: string;
  showDuplicateDateHint: boolean = true;
  isFlash: boolean = true;
  maxDateInDate: Date;
  maxDate: string;
  selectedBundle: VetineoVisitTypeBundle;
  vetDoctorVetVisitType: VisitType;

  constructor(
    public commonUtils: CommonUtils,
    private userService: UserService,
    private appStateService: AppStateService,
    private modalController: ModalController
  ) {
  }

  ngOnDestroy(): void {
    if (this.petsSub) {
      this.petsSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.useVetineoVisitTypes = this.clinicData?.useVetineoVisitTypes;
    if (this.nextVisitReminderSettings && this.nextVisitReminderSettings?.visitTypeDaysDelay && !this.nextVisitReminder.isFlash) {
      if (new Date(new Date().setDate(new Date(this.nextVisitReminder?.vaccNextDate).getDate() - Number.parseInt(this.nextVisitReminderSettings?.visitTypeDaysDelay))).getDate() >= new Date().getTime()) {
        this.days = Number.parseInt(this.nextVisitReminderSettings?.visitTypeDaysDelay);
      }
    }

    this.minDate = this.commonUtils.dateToYearMonthDayString(new Date(new Date().setDate(new Date().getDate() + 1)));
    this.maxDateInDate = new Date();
    this.maxDateInDate.setFullYear(this.maxDateInDate.getFullYear() + 2);
    this.maxDate = this.commonUtils.dateToYearMonthDayString(this.maxDateInDate);
    this.nextVisitReminder.scheduledFirstMessage = this.minDate;
    if (this.nextVisitReminder.vaccNextDate) {
      this.initVaccNextDateString = this.commonUtils.dateToYearMonthDayString(new Date(this.nextVisitReminder.vaccNextDate));
      if (new Date(this.nextVisitReminder.vaccNextDate) > new Date()) {
        this.valueSelected = this.commonUtils.dateToYearMonthDayString(new Date(this.nextVisitReminder.vaccNextDate));
      } else {
        this.calendarClicked = true;
        this.valueSelected = this.minDate;
        this.nextVisitReminder.vaccNextDate = new Date(this.valueSelected);
        this.showDuplicateDateHint = false;
      }
    } else {
      this.valueSelected = this.minDate;
      this.nextVisitReminder.vaccNextDate = new Date(this.valueSelected);
    }

    if (this.type === 'users') {
      this.petsSub = this.userService.getAllPetsByUser(this.nextVisitReminder.userUUID).subscribe(p => {
        this.pets = p;
        console.log(this.pets);
        console.log(this.nextVisitReminder)
        if (this.nextVisitReminder.petUUID) {
          this.selectedPet = this.pets.filter((pet) => pet.uuid === this.nextVisitReminder.petUUID)[0];
          if (this.selectedPet && this.useVetineoVisitTypes) {

            let grVisitTypes = new Map();
            for (const visitType of this.clinicData.visitTypes) {
              if (visitType.allPetSpecies || visitType.petSpecies.filter(e => e === this.selectedPet.petSpeciesKey)[0]) {
                let groupedVisitTypes: VisitType[] = [];

                if (grVisitTypes.has(visitType.bundleUUID.trim())) {
                  groupedVisitTypes = grVisitTypes.get(visitType.bundleUUID.trim());
                }

                groupedVisitTypes.push(visitType);

                grVisitTypes.set(visitType.bundleUUID.trim(), groupedVisitTypes);
              }
            }
            this.clinicData.groupedVisitTypes = grVisitTypes;
          }

        }
      }, error => {
      });

    }

    if (this.useVetineoVisitTypes) {
      if (this.nextVisitReminder.vetineoVisitTypeBundleUUID) {
        this.onBundleSelected(this.nextVisitReminder.vetineoVisitTypeBundleUUID);
        if (this.nextVisitReminder.doctorId) {
          this.selectedDoctor = this.clinicData?.doctors.filter(e => e.doctorId === this.nextVisitReminder.doctorId)[0];
        }
      }
    }

    if (this.nextVisitReminder.visitType && !this.useVetineoVisitTypes) {
      this.handleGroupedVisitTypeSelected(this.nextVisitReminder.visitType);
      if (this.nextVisitReminder.doctorId) {
        this.selectedDoctor = this.clinicData?.doctors.filter(e => e.doctorId === this.nextVisitReminder.doctorId)[0];
        console.log(this.selectedDoctor);
        this.nextVisitReminder.vetDoctorVetVisitTypeUUID = this.getVetDoctorVetVisitType()?.vetDoctorVetVisitTypeUUID;
        this.vetDoctorVetVisitType = this.getVetDoctorVetVisitType();
      }
    }


    if (this.nextVisitReminder.isImportant) {
      this.isImportant = true;
    }


    if (this.petFromVr && this.type === 'reservation' && this.nextVisitReminder.vetineoVisitUUID) {
      this.selectedPet = this.petFromVr;
      if (this.selectedPet && this.useVetineoVisitTypes) {

        let grVisitTypes = new Map();
        for (const visitType of this.clinicData.visitTypes) {
          if (visitType.allPetSpecies || visitType.petSpecies.filter(e => e === this.selectedPet.petSpeciesKey)[0]) {
            let groupedVisitTypes: VisitType[] = [];

            if (grVisitTypes.has(visitType.bundleUUID.trim())) {
              groupedVisitTypes = grVisitTypes.get(visitType.bundleUUID.trim());
            }

            groupedVisitTypes.push(visitType);

            grVisitTypes.set(visitType.bundleUUID.trim(), groupedVisitTypes);
          }
        }
        this.clinicData.groupedVisitTypes = grVisitTypes;
      }
    }
  }

  getGroupedVisitTypesKeys() {
    if (this.clinicData.visitTypes) {
      let visitTypes = Array.from(this.clinicData?.groupedVisitTypes.keys());
      if (!this.useVetineoVisitTypes) {
        visitTypes.push('Brak typu')
      }
      return visitTypes;
    } else {
      return null;
    }
  }

  getDoctors() {
    if (!this.useVetineoVisitTypes) {
      if (this.doctors) {
        let docs = [...this.doctors];
        let emptyDoctor = new Doctor();
        emptyDoctor.doctorName = 'brak';
        docs.push(emptyDoctor);
        return docs;
      } else {
        return null;
      }
    } else {
      if (this.selectedPet) {
        let doctors = this.selectedGVisitsTypeObj?.filter(e => e.allPetSpecies || e.petSpecies.filter(s => s === this.selectedPet.petSpeciesKey)[0]).map(visType => visType.doctorId).map(docId => this.clinicData?.doctors.filter(e => e.doctorId === docId)[0]).filter(e => e !== undefined)
        let docs = [];
        if (doctors) {
          docs = [...doctors];
        }
        let emptyDoctor = new Doctor();
        emptyDoctor.doctorName = 'brak';
        docs.push(emptyDoctor);
        return docs;
      } else {
        if (this.doctors) {
          let docs = [...this.doctors];
          let emptyDoctor = new Doctor();
          emptyDoctor.doctorName = 'brak';
          docs.push(emptyDoctor);
          return docs;
        } else {
          return null;
        }
      }
    }
  }

  onGroupedVisitTypeSelected(event) {
    this.handleGroupedVisitTypeSelected(event?.detail?.value);
  }

  private handleGroupedVisitTypeSelected(selectedValue) {
    if (selectedValue === 'Brak typu') {
      this.selectedGVisitType = null;
      this.nextVisitReminder.visitType = null;
      this.doctors = this.clinicData.doctors;
      this.nextVisitReminder.doctorId = null;
      this.selectedDoctor = null;
    } else {
      this.selectedGVisitType = selectedValue;
      if (this.clinicData.groupedVisitTypes && this.clinicData.groupedVisitTypes.has(this.selectedGVisitType)) {
        this.selectedGVisitsTypeObj = this.clinicData.groupedVisitTypes.get(this.selectedGVisitType);
        this.nextVisitReminder.visitType = this.selectedGVisitType
        if (this.selectedGVisitsTypeObj.filter(e => e.doctorId === 0).length === 1) {
          this.doctors = this.clinicData.doctors
        } else {
          this.doctors = this.selectedGVisitsTypeObj.map(visType => visType.doctorId).map(docId => this.clinicData.doctors.filter(e => e.doctorId === docId)[0]).filter(e => e !== undefined)
        }
      }

      if (this.nextVisitReminder?.doctorId && this.doctors?.filter((d) => d.doctorId === this.nextVisitReminder.doctorId)?.length == 0) {
        this.nextVisitReminder.doctorId = undefined;
        this.nextVisitReminder.doctorName = undefined;
        this.selectedDoctor = undefined;
      }
    }
  }

  changeCalendarValue(event) {
    if (!this.calendarClicked) {
      this.calendarClicked = true;
    }
    this.nextVisitReminder.vaccNextDate = event.detail.value;
    this.valueSelected = event.detail.value;
  }

  handleIsImportantToggle(nextVisitReminder: NextVisitReminder, $event) {
    if ($event.detail.checked) {
      this.isImportant = true;
    } else {
      this.isImportant = false;
    }

    this.nextVisitReminder.isImportant = this.isImportant;
  }

  calculateDateDiffInDays(date1: Date, date2: Date) {
    const oneDayMilliseconds = 86400000; // 1000 * 60 * 60 * 24
    const date1InMilliseconds = new Date(date1).getTime();
    const date2InMilliseconds = new Date(date2).getTime();
    const timeDifference = Math.abs(date2InMilliseconds - date1InMilliseconds);
    const daysDifference = Math.ceil(timeDifference / oneDayMilliseconds);
    return daysDifference;
  }

  onPetSelected($event, petSelect: HTMLIonSelectElement) {
    if (!$event.detail.value?.uuid) {
      this.nextVisitReminder.petUUID = null;
      this.nextVisitReminder.aniName = null;
      petSelect.value = null;
      this.pets = this.pets.filter(e => e.uuid);
    } else {
      let pet = new Pet();
      pet.name = 'Inne zwierzę';
      if (this.pets && !this.differentPetOptionExists()) {
        this.pets.push(pet);
      }
      this.nextVisitReminder.petUUID = $event.detail.value.uuid;
      this.nextVisitReminder.aniName = $event.detail.value.name;
    }
  }

  differentPetOptionExists() {
    return this.pets.filter(pet => !pet.uuid).length !== 0;

  }

  handleIsNeededPhone(nextVisitReminder: NextVisitReminder, $event) {
    this.nextVisitReminder.isPhoneNeeded = $event.detail.checked
  }


  onDoctorSelected($event, doctorSelected: HTMLIonSelectElement) {
    if ($event?.detail?.value?.doctorId && $event?.detail?.value?.doctorName) {
      this.nextVisitReminder.doctorId = $event.detail.value.doctorId;
      this.nextVisitReminder.doctorName = $event.detail.value.doctorName;
      if (this.useVetineoVisitTypes) {
        this.nextVisitReminder.vetDoctorVetVisitTypeUUID = this.getVetDoctorVetVisitType()?.vetDoctorVetVisitTypeUUID;
        this.vetDoctorVetVisitType = this.getVetDoctorVetVisitType();
        this.selectedPet = null;
        this.nextVisitReminder.petUUID = null;
      }

    } else {
      if ($event?.detail?.value?.doctorName === 'brak') {
        this.nextVisitReminder.doctorId = null;
        this.nextVisitReminder.doctorName = null;
        this.selectedDoctor = null;
        doctorSelected.value = null;
        if (this.useVetineoVisitTypes) {
          this.nextVisitReminder.vetDoctorVetVisitTypeUUID = null;
          this.vetDoctorVetVisitType = null;
          this.selectedPet = null;
          this.nextVisitReminder.petUUID = null;
        }
      }
    }
  }

  getPetSelectPlaceholder() {
    return (!this.pets || this.pets.length === 0) ? 'Użytkownik nie ma dodanych zwierząt' : 'Wybierz zwierzę';
  }

  isReminderValid() {
    if (this.isCopy) {
      return !(!this.calendarClicked || (this.nextVisitReminder?.vaccNextDate.toString() === this.initVaccNextDateString)) && (this.nextVisitReminder.scheduledFirstMessage && ((this.nextVisitReminder.visitType || this.selectedGVisitType) || this.nextVisitReminder.isPhoneNeeded) && (this.nextVisitReminder.petUUID || this.nextVisitReminder.aniName));
    }
    return this.nextVisitReminder.scheduledFirstMessage && ((this.nextVisitReminder.visitType || this.selectedGVisitType) || this.nextVisitReminder.isPhoneNeeded) && (this.nextVisitReminder.petUUID || this.nextVisitReminder.aniName);

  }

  onSubmitReminder() {
    this.nextVisitReminder.created = new Date();
    this.nextVisitReminder.isFlash = this.isFlash;

    if (this.useVetineoVisitTypes) {
      this.nextVisitReminder.vetineoVisitTypeBundleUUID = this.selectedGVisitType;
      if (this.selectedDoctor) {
        this.nextVisitReminder.vetDoctorVetVisitTypeUUID = this.getVetDoctorVetVisitType()?.vetDoctorVetVisitTypeUUID;
      }
    }

    if (this.type === 'reservation') {
      this.nextVisitReminder.petUUID = this.petFromVr.uuid;
    }

    this.modalController.dismiss(this.nextVisitReminder, 'submit');
  }

  onBundleSelected(selectedValue) {
    this.vetDoctorVetVisitType = null;
    this.selectedGVisitType = selectedValue;
    this.selectedDoctor = null;
    if (selectedValue === 'Brak typu') {
      this.selectedBundle = null;
      this.selectedGVisitType = null;
      this.nextVisitReminder.visitType = null;
      this.doctors = this.clinicData.doctors;
      this.nextVisitReminder.doctorId = null;
      this.selectedDoctor = null;
    } else {
      if (this.clinicData.groupedVisitTypes && this.clinicData.groupedVisitTypes.has(this.selectedGVisitType)) {
        this.selectedBundle = this.clinicData.vetineoVisitTypeBundles.filter(e => e.uuid === this.selectedGVisitType)[0];
        this.selectedGVisitsTypeObj = this.clinicData.groupedVisitTypes.get(this.selectedGVisitType);
        if (this.selectedGVisitsTypeObj.filter(e => e.doctorId === 0).length === 1) {
          this.doctors = this.clinicData.doctors
        } else {
          this.doctors = this.selectedGVisitsTypeObj.map(visType => visType.doctorId).map(docId => this.clinicData.doctors.filter(e => e.doctorId === docId)[0]).filter(e => e !== undefined)
        }
      }

      if (this.useVetineoVisitTypes && !(this.nextVisitReminder.uuid || this.isCopy)) {
        this.selectedPet = null;
        this.nextVisitReminder.petUUID = null;
      }

      if (this.nextVisitReminder?.doctorId && this.doctors.filter((d) => d.doctorId === this.nextVisitReminder.doctorId)?.length == 0) {
        this.nextVisitReminder.doctorId = undefined;
        this.nextVisitReminder.doctorName = undefined;
        this.selectedDoctor = undefined;
      }

    }
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  handleIsFlashToggle(nextVisitReminder: NextVisitReminder, $event) {
    if ($event.detail.checked) {
      this.isFlash = true;
    } else {
      this.isFlash = false;
    }

    this.nextVisitReminder.isFlash = this.isFlash;
  }

  getBundleName(bundleUUID: any) {
    if (bundleUUID === 'Brak typu') {
      return bundleUUID
    } else {
      const bundle = this.clinicData.vetineoVisitTypeBundles.filter(e => e.uuid === bundleUUID)[0];
      if (!bundle?.nameAdditionPL) {
        return bundle.namePL;
      } else {
        return `${bundle.namePL} ${bundle.nameAdditionPL}`;
      }
    }
  }

  private getVetDoctorVetVisitType() {
    if (this.selectedDoctor) {
      return this.selectedGVisitsTypeObj.filter(e => e.doctorId === this.selectedDoctor.doctorId)[0];
    }
    return null;
  }

  getPets() {
    if (this.useVetineoVisitTypes) {
      if (this.selectedGVisitsTypeObj) {
        if (this.vetDoctorVetVisitType) {
          if (this.vetDoctorVetVisitType.allPetSpecies) {
            return this.pets;
          } else {
            let ps = this.pets?.filter(pet => this.vetDoctorVetVisitType.petSpecies
              .map(v => v.replace(/^"|"$/g, ""))
              .filter(ps => ps === pet.petSpeciesKey)[0]);
            return ps
          }
        } else {
          if (this.selectedBundle.allPetSpecies) {
            return this.pets;
          } else {
            return this.pets?.filter(pet => this.selectedBundle.servedPetSpecies.filter(ps => ps.key === pet.petSpeciesKey)[0]);
          }
        }
      }
    } else {
      return this.pets;
    }
  }


  cantChoosePet() {
    if (this.useVetineoVisitTypes) {
      return !this.selectedBundle || (!this.getPets() || this.getPets()?.length === 0);
    } else {
      return (!this.pets || this.pets.length === 0);
    }
  }
}

